const menuRoot = document.querySelector('.js-open-secondary-menu');
const tertiaryMenus = Array.from(document.querySelectorAll('.js-open-tertiary-menu'));
const backButton = document.querySelector('.js-close-tertiary-menu');

const closeTertiaryMenus = () => {
    const activeMenus = Array.from(document.querySelectorAll('.secondary-dropdown-menu__secondary-menu .active'));
    activeMenus.forEach((menu) => {
        menu.classList.remove('active');
    });
};

if (menuRoot && backButton) {
    menuRoot.addEventListener('click', (event) => {
        menuRoot.classList.toggle('active');
        closeTertiaryMenus();
        menuRoot.classList.remove('active-tertiary');
        event.stopImmediatePropagation();
    });
    backButton.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        menuRoot.classList.remove('active-tertiary');
        closeTertiaryMenus();
    });
}

if (tertiaryMenus) {
    tertiaryMenus.forEach((menu) => {
        menu.addEventListener('click', (event) => {
            event.stopImmediatePropagation();
            menuRoot.classList.add('active-tertiary');
            const subMenu = menu.dataset.menu;
            document.querySelector(`[data-sub-menu='${subMenu}']`).classList.add('active');
        });
    });
}
